import { ToastController, BrandVariants } from "./fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { Union, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { TrackInactiveOverview_$reflection, Notification_$reflection, User_$reflection } from "./Shared/SharedModels.jsx";
import { union_type, record_type, int32_type, array_type, tuple_type, list_type, class_type, bool_type, option_type, string_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { ofArray, add } from "./fable_modules/fable-library-js.4.29.0/Map.js";
import { createContext } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Toaster, createLightTheme, createDarkTheme, FluentProvider, useToastController, useId } from "@fluentui/react-components";
import { comparePrimitives, createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";

export const iipBrands = new BrandVariants("#020404", "#101C1A", "#142E2B", "#173C37", "#184A44", "#195851", "#19675F", "#17766D", "#13867B", "#149589", "#43A297", "#62AFA5", "#7DBCB3", "#97C9C1", "#B0D6D0", "#C9E3DF");

export const terracottaTheme = new BrandVariants("#050201", "#21140E", "#381E17", "#4B261D", "#5F2F22", "#743728", "#89402E", "#9E4934", "#B5523A", "#CA5D43", "#D37057", "#DB836B", "#E39681", "#EAA996", "#F0BBAC", "#F5CEC3");

export const slateTheme = new BrandVariants("#020304", "#12191C", "#1B282F", "#21353E", "#29424E", "#314F5D", "#3C5C6C", "#4B6A78", "#5A7785", "#6B8592", "#7B929E", "#8CA0AB", "#9DAFB8", "#AEBDC5", "#C0CBD2", "#D2DADF");

export class ContextModel extends Record {
    constructor(User, AppVersion, NavbarOpen, ThemeType, ToastToUpdate, ToastToDismiss, NameIndex, Notifications, InactiveTracks, PendingApprovalCount) {
        super();
        this.User = User;
        this.AppVersion = AppVersion;
        this.NavbarOpen = NavbarOpen;
        this.ThemeType = ThemeType;
        this.ToastToUpdate = ToastToUpdate;
        this.ToastToDismiss = ToastToDismiss;
        this.NameIndex = NameIndex;
        this.Notifications = Notifications;
        this.InactiveTracks = InactiveTracks;
        this.PendingApprovalCount = (PendingApprovalCount | 0);
    }
}

export function ContextModel_$reflection() {
    return record_type("Context.ContextModel", [], ContextModel, () => [["User", User_$reflection()], ["AppVersion", option_type(string_type)], ["NavbarOpen", bool_type], ["ThemeType", ThemeType_$reflection()], ["ToastToUpdate", option_type(tuple_type(class_type("Fable.React.ReactElement"), list_type(string_type)))], ["ToastToDismiss", string_type], ["NameIndex", NameIndex_$reflection()], ["Notifications", array_type(Notification_$reflection())], ["InactiveTracks", array_type(TrackInactiveOverview_$reflection())], ["PendingApprovalCount", int32_type]]);
}

export class ThemeType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Light", "Dark"];
    }
}

export function ThemeType_$reflection() {
    return union_type("Context.ThemeType", [], ThemeType, () => [[], []]);
}

export class NameIndex extends Record {
    constructor(EventNames, UserNames, TrackNames, CourseNames) {
        super();
        this.EventNames = EventNames;
        this.UserNames = UserNames;
        this.TrackNames = TrackNames;
        this.CourseNames = CourseNames;
    }
}

export function NameIndex_$reflection() {
    return record_type("Context.NameIndex", [], NameIndex, () => [["EventNames", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, string_type])], ["UserNames", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, string_type])], ["TrackNames", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, string_type])], ["CourseNames", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, string_type])]]);
}

export class ContextMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateToast", "DismissToast", "UpdateUser", "UpdateNavbarOpen", "UpdateThemeType", "UpdateNotifications", "UpdateInactiveTracks", "AddEventMapping", "AddTrackMapping", "AddCourseMapping", "UpdatePendingApprovalCount"];
    }
}

export function ContextMsg_$reflection() {
    return union_type("Context.ContextMsg", [], ContextMsg, () => [[["Item", tuple_type(class_type("Fable.React.ReactElement"), list_type(string_type))]], [["Item", string_type]], [["Item", User_$reflection()]], [["Item", bool_type]], [["Item", ThemeType_$reflection()]], [["Item", array_type(Notification_$reflection())]], [["Item", array_type(TrackInactiveOverview_$reflection())]], [["Item1", int32_type], ["Item2", string_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item", int32_type]]]);
}

export function UpdateContext(model, msg) {
    let bind$0040, bind$0040_1, bind$0040_2;
    switch (msg.tag) {
        case 1:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, msg.fields[0], model.NameIndex, model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
        case 2:
            return new ContextModel(msg.fields[0], model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, model.NameIndex, model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
        case 3:
            return new ContextModel(model.User, model.AppVersion, msg.fields[0], model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, model.NameIndex, model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
        case 4:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, msg.fields[0], model.ToastToUpdate, model.ToastToDismiss, model.NameIndex, model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
        case 5:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, model.NameIndex, msg.fields[0], model.InactiveTracks, model.PendingApprovalCount);
        case 6:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, model.NameIndex, model.Notifications, msg.fields[0], model.PendingApprovalCount);
        case 7:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, (bind$0040 = model.NameIndex, new NameIndex(add(msg.fields[0], msg.fields[1], model.NameIndex.EventNames), bind$0040.UserNames, bind$0040.TrackNames, bind$0040.CourseNames)), model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
        case 8:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, (bind$0040_1 = model.NameIndex, new NameIndex(bind$0040_1.EventNames, bind$0040_1.UserNames, add(msg.fields[0], msg.fields[1], model.NameIndex.TrackNames), bind$0040_1.CourseNames)), model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
        case 9:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, (bind$0040_2 = model.NameIndex, new NameIndex(bind$0040_2.EventNames, bind$0040_2.UserNames, bind$0040_2.TrackNames, add(msg.fields[0], msg.fields[1], model.NameIndex.CourseNames))), model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
        case 10:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss, model.NameIndex, model.Notifications, model.InactiveTracks, msg.fields[0]);
        default:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, msg.fields[0], model.ToastToDismiss, model.NameIndex, model.Notifications, model.InactiveTracks, model.PendingApprovalCount);
    }
}

export const context = createContext(undefined, undefined);

export function ContextProvider(contextProviderInputProps) {
    let el_2;
    const children = contextProviderInputProps.children;
    const session = contextProviderInputProps.session;
    const toasterId = useId("toaster", undefined);
    let toastController;
    const controller = useToastController(toasterId);
    toastController = (new ToastController((tupledArg) => {
        const options_1 = createObj(tupledArg[1]);
        controller.dispatchToast(tupledArg[0], options_1);
    }, (props) => {
        controller.dismissToast(props);
    }, (props_1) => {
        controller.dismissAllToasts();
    }, (props_2) => {
        controller.updateToast(createObj(props_2));
    }, (props_3) => {
        controller.pauseToast(props_3);
    }, (props_4) => {
        controller.playToast(props_4);
    }));
    let patternInput;
    const arg_1 = new ContextModel(session.User, session.AppVersion, true, new ThemeType(0, []), undefined, "", new NameIndex(ofArray(session.EventNames, {
        Compare: comparePrimitives,
    }), ofArray(session.UserNames, {
        Compare: comparePrimitives,
    }), ofArray(session.TrackNames, {
        Compare: comparePrimitives,
    }), ofArray(session.CourseNames, {
        Compare: comparePrimitives,
    })), [], [], 0);
    patternInput = reactApi.useReducer(UpdateContext, arg_1);
    const ctx = patternInput[0];
    const dependencies = [ctx.ToastToUpdate];
    reactApi.useEffect(() => {
        const matchValue = ctx.ToastToUpdate;
        if (matchValue != null) {
            toastController.dispatchToast(matchValue);
        }
    }, dependencies);
    const dependencies_2 = [ctx.ToastToDismiss];
    reactApi.useEffect(() => {
        toastController.dismissToast(ctx.ToastToDismiss);
    }, dependencies_2);
    let child;
    const xs = [(el_2 = FluentProvider, createElement(el_2, createObj(toList(delay(() => append((ctx.ThemeType.tag === 1) ? singleton(["theme", createDarkTheme(iipBrands)]) : singleton(["theme", createLightTheme(iipBrands)]), delay(() => {
        let elems;
        return singleton((elems = toList(delay(() => append(children, delay(() => {
            let el;
            return singleton((el = Toaster, createElement(el, {
                toasterId: toasterId,
            })));
        })))), ["children", reactApi_1.Children.toArray(Array.from(elems))]));
    })))))))];
    child = react.createElement(react.Fragment, {}, ...xs);
    return reactApi.createElement(context.Provider, {
        value: [ctx, patternInput[1]],
    }, child);
}

export function useCtx() {
    return reactApi.useContext(context);
}

//# sourceMappingURL=Context.jsx.map
